import React, { useState, useEffect } from 'react';
import MegaMenu from '../components/MegaMenu';
import MobileMegaMenu from '../components/MobileMegaMenu';

const Navbar = () => {
  const [isMobile, setIsMobile] = useState(false); // Initialize with false by default

  const checkIfMobile = () => {
    // Safely check window existence
    if (typeof window !== 'undefined') {
      setIsMobile(window.innerWidth <= 991);
    }
  };

  useEffect(() => {
    // Initial check
    checkIfMobile();
    
    // Add resize listener
    window.addEventListener('resize', checkIfMobile);
    
    // Cleanup
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  // Render nothing until we know the screen size (optional)
  if (isMobile === null) return null;

  return (
    <>
      

      {isMobile ? <MobileMegaMenu /> : <MegaMenu />}
    </>
  );
};

export default Navbar;